import * as React from 'react';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { connect } from 'react-redux';

interface IProps extends CommonProps {
  cargoType: string;
  cargoSubTypes: Record<string, string[]>;
}

const SelectProductType = (props: IProps) => {

  const {
    mode,
    style,
    value,
    disabled,
    onChange,
    cargoSubTypes,
    className,
    cargoType,
    placeholder,
  } = props;

  const renderOptions = () => {
    return cargoSubTypes[cargoType]?.map((item) => {
      return <Select.Option
        key={item}
        data-value={item}>
        {item}
      </Select.Option>;
    }) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    dropdownMatchSelectWidth={false}
    placeholder={placeholder || 'Select Product Type'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderOptions()}
  </Select>;
};

const mapStateToProps = ({ staticData }, ownProps) => {
  const { product } = staticData || {};
  return {
    product,
  };
};

export default React.memo(connect(mapStateToProps)(SelectProductType));
